import { oneOf } from 'prop-types';

export default oneOf(['ok', 'warning', 'problem', 'disconnected']);



// WEBPACK FOOTER //
// ./src/propTypes/segmentStatus.js